<template>
    <div v-if="showDetail == true">
        <!--v-flex xs12 sm12 md8 lg8 xl8 style="margin: auto">
            <v-card>
                <v-card-text>
                    <v-form @keyup.enter.native="onSave">
                        <v-layout>
                            <v-flex style="font-size: 40px;color:#3b5998;border-bottom: 1px solid #3b5998;">
                                {{exercise.name}}
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.dueDate')}}:</label>
                                {{exercise.dueDate | formatDate}}
                            </v-flex>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.effectiveDate')}}:</label>
                                {{exercise.effectiveDate | formatDate}}
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.subject')}}:</label>
                                {{exercise.subject}}
                            </v-flex>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.markScale')}}:</label>
                                {{exercise.markScale}}
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.questionTime')}}:</label>
                                {{exercise.questionTime}}
                            </v-flex>
                            <v-flex xs12 sm6 md6 lg6 xl6>
                                <label class="label">{{$t('lang.exercise.numberOfQuiz')}}:</label>
                                {{exercise.numberOfQuiz}}
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="cancel" @click="cancel">
                        {{ $t('lang.common.back') }}
                    </v-btn>
                    <v-btn class="yoprimary" dark @click="doExercise">
                        {{$t('lang.exercise.doExercise')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex-->
    </div>
    <div v-else>
        <do-quiz :question="exercise" :class-id="classId" :key="exercise.questionId" v-if="objectType==6" @onback="back"
                 @reload="onReloadExercise"/>
        <do-essay :question="exercise" :class-id="classId" :key="exercise.questionId" v-else @onback="back"/>
    </div>
</template>

<script>
    import {message} from '../../services';
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios"
    import IUpload from "../../components/form/Upload";
    import DoQuiz from "./doQuiz";
    import DoEssay from "./doEssay";

    export default {
        name: "student-view-question",
        components: {
            DoEssay,
            DoQuiz,
            IUpload,
            IDatepicker,
        },

        props: {
            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },
            objectType: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },

            question: {
                type: Object,
                default: () => {
                    return null;
                }
            }

        },
        data() {
            return {
                clazz: {},
                showDetail: true,
                accept: ".pdf, .doc, .docx, image/*",
                exercise: {
                    "name": "",
                    "subject": "",
                    "dueDate": new Date(),
                    "effectiveDate": new Date(),
                    "markScale": 10,
                    "content": "",
                }
            }
        },

        watch: {
            question: function (data) {
                ////console.log("question change");
                ////console.log(data);
            }
        },

        created() {
            if (this.question != null) {
                this.exercise = this.question;
                if (this.question.examId != undefined) {
                    this.exercise.examId = this.question.examId;
                }
                if (this.question.source != undefined) {
                    this.exercise.source = this.question.source;
                }
                /*
                                this.exercise.questionId = this.question.questionId;
                                this.exercise.name = this.question.name;
                                this.exercise.subject = this.question.subject;
                                this.exercise.dueDate = this.question.dueDate;
                                this.exercise.effectiveDate = this.question.effectiveDate;
                                this.exercise.markScale = this.question.markScale;
                                this.exercise.content = this.question.content;
                                this.exercise.attachId = this.question.attachId;
                                this.exercise.attachType = this.question.attachType;
                                this.exercise.numberOfQuiz = this.question.numberOfQuiz;
                                this.exercise.question = this.question.question;
                                this.exercise.questionTime = this.question.questionTime;
                                this.exercise.attachs = this.question.attachs;
                                this.exercise.permission = this.question.permission;
                                this.exercise.answerAttachId = this.question.answerAttachId;
                                this.exercise.answerAttachType = this.question.answerAttachType;
                */
            }
            this.doExercise();
        },

        methods: {
            onReloadExercise() {
                this.showDetail = true;
                this.doExercise();
            },

            doExercise() {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/startDoExercise?classId=" + this.classId + "&exerciseId=" + this.question.questionId + "&exerciseType=" + this.objectType).then(
                    data => {
                        if (data.success) {
                            if (data.ref != undefined && data.ref != null) {
                                //console.log(data.ref);
                                this.exercise.answer = data.ref;
                                /*
                                                                if(this.objectType == 6) {
                                                                    this.exercise.answer = data.ref.answer;
                                                                } else {
                                                                    this.exercise.answer = {
                                                                        'attachId':data.ref.attachId,
                                                                        'attachType':data.ref.attachType,
                                                                        'status':data.ref.status
                                                                    }
                                                                }
                                */
                            }
                            this.showDetail = false;
                        } else {
                            message.error(this.$t(data.description));
                        }
                    },
                    error => {
                        //console.log(error);
                    }
                );
            },

            cancel: function () {
                this.$emit("onCancelCreate");
            },

            back: function () {
                this.showDetail = true;
                this.cancel();
            },

            openFileDialog() {
                document.getElementById("essayUpload").click();
            },
        }
    };
</script>

